var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.finished)?_c('div',{staticClass:"quiz-actions"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){$event.preventDefault();return _vm.$emit('next')}}},[_vm._v("\n    შემდეგი\n  ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }